<template>
    <div class="wrapper" v-show="this.loaded">
            
            <div class="sidebar" data-color="blue" style="background: blue;">
                <div class="sidebar-wrapper">
                    <div class="logo">
                        <a class="simple-text">
                            Click2Date
                        </a>
                    </div>
                    <ul class="nav">
                        <li class="nav-item active" style="width: 100%; margin: 0;">
                            <router-link class="nav-link" to="/admin/dashboard">
                                <i class="nc-icon  nc-atom"></i>
                                <p>Dashboard</p>
                            </router-link>
                        </li>
                        
                        <li class="nav-item active" style="width: 100%; margin: 0;">
                            <router-link class="nav-link" to="/admin/employees">
                                <i class="nc-icon nc-tag-content"></i>
                                <p>Employees</p>
                            </router-link>
                        </li>
                        <!-- 
                        <li class="nav-item active" style="width: 100%; margin: 0; position: absolute; left: 0; bottom: 25px;">
                            <a @click="logout" class="nav-link" style="cursor: pointer;" to="/admin/employees">
                                <i class="nc-icon nc-simple-remove"></i>
                                <p>Logout</p>
                            </a>
                        </li>
                        -->
                    </ul>
                </div>
            </div>
            <div class="main-panel">
                <!-- Navbar -->
                <h1 v-show="!this.loaded">Loading ...</h1>
                <nav class="navbar navbar-expand-lg " color-on-scroll="500">
                    <div class=" container-fluid">
                        <a class="navbar-brand" href="#"> Dashboard </a>
                        <button href="" class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse1" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
                            <span class="navbar-toggler-bar burger-lines"></span>
                            <span class="navbar-toggler-bar burger-lines"></span>
                            <span class="navbar-toggler-bar burger-lines"></span>
                        </button>
                        <div class="collapse navbar-collapse justify-content-end" id="navigation">
                            <b-alert variant="success"
                                    dismissible
                                    :show="showDismissibleAlert"
                                    @dismissed="showDismissibleAlert=false">
                                Gespeichert!
                            </b-alert>
                            <button @click="saveData" style="margin-top: 15px;" class="btn btn-primary">Speichern</button>
                        </div>
                    </div>
                </nav>
                <!-- End Navbar -->
                <div class="content">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card ">
                                    <div class="card-header ">
                                        <h4 class="card-title">Firmenlogo</h4>
                                        <p class="card-category">Ihr Firmenlogo</p>
                                    </div>
                                    <div class="card-body ">
                                      <img width="150" v-bind:src="'/OTeV/userdata/images/' + this.companyID + '/' + this.companyID + '-' 
                                        + 'default' + '-Logo.jpg'"/>
                                        <picture-input
                                            ref="pictureInput"
                                            @change="onLogoChanged"
                                            @remove="onLogoRemoved"
                                            :width="500"
                                            :removable="true"
                                            removeButtonClass="ui red button"
                                            :height="100"
                                            accept="image/jpeg"
                                            buttonClass="btn btn-primary"
                                            :customStrings="{
                                            upload: '<h1>Jetzt hochladen</h1>',
                                            drag: 'Hochladen'}">
                                        </picture-input>
                                        <button style="margin-top: 15px;" class="btn btn-primary" @click="attemptUpload">
                                            Upload
                                        </button>
                                        
                                    </div>
                                    <div class="card-footer">
                                        
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="card ">
                                    <div class="card-header" v-b-toggle.collapse1>
                                        <h4 class="card-title">Einstellungen</h4>
                                        <p class="card-category">Diverse Werte und Anpassungen für Ihren persönlichen Firmenauftritt</p>
                                    </div>
                                    <b-collapse id="collapse1">
                                    <div class="card-body">
                                        <input v-model="customizeData.ColorHex" type="text" class="form-control" value="" style="margin-bottom: 15px;" />
                                        <input v-b-tooltip.hover title="Slot Pitch" v-model="customizeData.SlotPitch" style="margin-bottom: 15px;" class="form-control" placeholder="SlotPitch" type="text" />
                                        <input v-b-tooltip.hover title="DayOffset" v-model="customizeData.dayOffset" style="margin-bottom: 15px;" class="form-control" placeholder="DayOffset" type="text" />
                                        <input v-b-tooltip.hover title="Google Maps URL" v-model="customizeData.IframURL" style="margin-bottom: 15px;" class="form-control" placeholder="Google Maps URL" type="text" />
                                    </div>
                                    </b-collapse>
                                    <div class="card-footer ">
                                    </div>
                                </div>

                                <div class="card ">
                                    <div class="card-header" v-b-toggle.collapse2>
                                        <h4 class="card-title">Texte</h4>
                                        <p class="card-category">Diverse Werte und Anpassungen für Ihren persönlichen Firmenauftritt</p>
                                    </div>
                                    <b-collapse id="collapse2">
                                    <div class="card-body">
                                    <input v-b-tooltip.hover title="Landing Message" v-model="customizeData.LandingMessage" style="margin-bottom: 15px;" class="form-control" placeholder="Landing Message" type="text" />
                                    <input v-b-tooltip.hover title="Landing Sub Message" v-model="customizeData.LandingText" style="margin-bottom: 15px;" class="form-control" placeholder="Landing Text" type="text" />
                                    <input v-b-tooltip.hover title="Nachricht beim erfolgreichen Versenden der Anfrage" v-model="customizeData.EndMessage" style="margin-bottom: 15px;" class="form-control" placeholder="Abschlussnachricht" type="text" />
                                    <input v-b-tooltip.hover title="Error Nachricht bei nicht vorhandenem Termin" v-model="customizeData.ErrorMessage" style="margin-bottom: 15px;" class="form-control" placeholder="Error Message" type="text" />
                                    <input v-model="customizeData.IframHeader" style="margin-bottom: 15px;" class="form-control" placeholder="Sub Head Branch" type="text" />
                                    <input v-model="customizeData.IframFooter" style="margin-bottom: 15px;" class="form-control" placeholder="Sub Head Employee" type="text" />
                                    </div>
                                    </b-collapse>
                                    <div class="card-footer ">
                                    </div>
                                </div>

                                <div class="card ">
                                    <div class="card-header" v-b-toggle.collapse3>
                                        <h4 class="card-title">Überschriften</h4>
                                        <p class="card-category">Hauptüberschriften der Tabs</p>
                                    </div>
                                    <b-collapse id="collapse3">
                                    <div class="card-body">
                                    <input v-b-tooltip.hover title="Schriftfarbe" v-model="customizeData.HeadColor" style="margin-bottom: 15px;" class="form-control" placeholder="Schriftfarbe" type="text" />
                                    <input v-b-tooltip.hover title="Title Tab 1" v-model="customizeData.HeadService" style="margin-bottom: 15px;" class="form-control" placeholder="Head Service" type="text" />
                                    <input v-b-tooltip.hover title="Title Tab 2" v-model="customizeData.HeadBranch" style="margin-bottom: 15px;" class="form-control" placeholder="Head Branch" type="text" />
                                    <input v-b-tooltip.hover title="Title Tab 3" v-model="customizeData.HeadEmployee" style="margin-bottom: 15px;" class="form-control" placeholder="Head Employee" type="text" />
                                    <input v-model="customizeData.HeadAppt" style="margin-bottom: 15px;" class="form-control" placeholder="Head Appt" type="text" />
                                    <input v-model="customizeData.HeadContact" style="margin-bottom: 15px;" class="form-control" placeholder="Head Contact" type="text" />
                                    <input v-model="customizeData.HeadSummary" style="margin-bottom: 15px;" class="form-control" placeholder="Head Summary" type="text" />
                                    </div>
                                    </b-collapse>
                                    <div class="card-footer ">
                                    </div>
                                </div>

                                 <div class="card ">
                                    <div class="card-header" v-b-toggle.collapse4>
                                        <h4 class="card-title">Überschriften 2</h4>
                                        <p class="card-category">Subüberschriften der Tabs</p>
                                    </div>
                                    <b-collapse id="collapse4">
                                    <div class="card-body">
                                    <input v-model="customizeData.SubHeadService" style="margin-bottom: 15px;" class="form-control" placeholder="Sub Head Service" type="text" />
                                    <input v-model="customizeData.SubHeadBranch" style="margin-bottom: 15px;" class="form-control" placeholder="Sub Head Branch" type="text" />
                                    <input v-model="customizeData.SubHeadEmployee" style="margin-bottom: 15px;" class="form-control" placeholder="Sub Head Employee" type="text" />
                                    <input v-model="customizeData.SubHeadAppt" style="margin-bottom: 15px;" class="form-control" placeholder="Sub Head Appt" type="text" />
                                    <input v-model="customizeData.SubHeadContact" style="margin-bottom: 15px;" class="form-control" placeholder="Sub Head Contact" type="text" />
                                    <input v-model="customizeData.SubHeadSummary" style="margin-bottom: 15px;" class="form-control" placeholder="Sub Head Summary" type="text" />
                                    </div>
                                    </b-collapse>
                                    <div class="card-footer ">
                                    </div>
                                </div>

                                <div class="card ">
                                    <div class="card-header" v-b-toggle.collapse5>
                                        <h4 class="card-title">Buttons</h4>
                                        <p class="card-category">Beschriftungen der Buttons</p>
                                    </div>
                                    <b-collapse id="collapse5">
                                    <div class="card-body">
                                    <input v-b-tooltip.hover title="Text des Buttons auf der Intro Seite" v-model="customizeData.ButtonStart" style="margin-bottom: 15px;" class="form-control" placeholder="Start Button" type="text" />
                                    <input v-b-tooltip.hover title="Button Anfrage Senden" v-model="customizeData.ButtonSend" style="margin-bottom: 15px;" class="form-control" placeholder="Senden" type="text" />
                                    <input v-b-tooltip.hover title="Button Schließen" v-model="customizeData.ButtonClose" style="margin-bottom: 15px;" class="form-control" placeholder="Beenden" type="text" />
                                    <input v-b-tooltip.hover title="Button Übersicht" v-model="customizeData.ButtonSum" style="margin-bottom: 15px;" class="form-control" placeholder="Bestätigen" type="text" />
                                    </div>
                                    </b-collapse>
                                    <div class="card-footer ">
                                    </div>
                                </div>
                
                                 
                            </div>
                        </div>
                    </div>
                </div>
                <footer class="footer">
                    <div class="container">
                        <nav>
                        
                            <p class="copyright text-center">
                                ©
                                2018
                                CLICK2Date, ein Service von <a href="https://ipro.de">Ipro GmbH</a>
                            </p>
                        </nav>
                    </div>
                </footer>
            </div>
</div>
</template>


<script>

import '../assets/demo.css'
import '../assets/light-bootstrap-dashboard.css'


export default {
  name: "DashboardView",
  components: {
  },
  data() {
    return {
      customizeData : {},
      companyID: "-1",
      noAccessURL: process.env.NOACCESSURL,
      showDismissibleAlert: false,
      loaded: false
    };
  },
  methods: {
    onLoad: function() {
      var token = this.$route.query.token || '-1';

      if(token == "hallo")
      {
            this.companyID = "7777";
            this.$localStorage.set('CompanyID', this.companyID);
            this.loadCompanyInfo();
          return;
      }
        if(token != "-1")
        {
          this.$localStorage.remove('CompanyID');
          var formData = new FormData();

          formData.append("t", token);

          this.$http.post("https://webservice.ipro.de/lisa/lisa_ticketinfo.json", formData).then(
              response => {
                  console.log(response.body);
                  if(response.body.error)
                  {
                      console.log("Token not valid");
                      this.$router.push({ name: "ErrorView", params: { ErrorHeader: "TOKEN NOT VALID",ErrorSubHeader: "Das Token ist nicht mehr gültig oder fehlerhaft" }});
                  }
                  else
                  {
                      this.companyID = response.body.sid;
                      this.$localStorage.set('CompanyID', this.companyID);
                      this.loadCompanyInfo();
                  }
              }, response => { });
        }
        else
        {
          console.log("No TOKEN");
          var cID = this.$localStorage.get('CompanyID');
          console.log(cID);
          if(cID)
          {
            console.log(cID);
            console.log("Loaded from Store");
            this.companyID = cID;
            this.loadCompanyInfo();
          }
          else
          {
            console.log("No ID in storage");
            this.$router.push({ name: "ErrorView", params: { ErrorHeader: "NOT AUTHENTICATED", ErrorSubHeader: "Token fehlt."}});
          }
        }


      

    },
    loadCompanyInfo: function()
    {
      this.$http.get(this.noAccessURL + 'getAppointment.php?action=personalize&companyId=' + this.companyID).then(response => {

          this.customizeData = response.body[0];
          console.log(response.body);
          this.loaded = true;
        }, response => 
        {
          // error callback
        });
    },
    logout: function ()
    {
        this.$localStorage.remove("CompanyID");
        this.$router.push({ name: "ErrorView", params: { ErrorHeader: "Log Out erfolgreich", ErrorSubHeader: "Bis bald!"}  });
    },
    saveData()
    {

        var formData = new FormData();

        formData.append("ColorHex", this.customizeData.ColorHex);
        formData.append("LandingMessage", this.customizeData.LandingMessage);
        formData.append("LandingText", this.customizeData.LandingText);
        formData.append("EndMessage", this.customizeData.EndMessage);
        formData.append("SlotPitch", this.customizeData.SlotPitch);

        formData.append("HeadColor", this.customizeData.HeadColor);
        formData.append("HeadService", this.customizeData.HeadService);
        formData.append("HeadBranch", this.customizeData.HeadBranch);
        formData.append("HeadEmployee", this.customizeData.HeadEmployee);
        formData.append("HeadAppt", this.customizeData.HeadAppt);
        formData.append("HeadContact", this.customizeData.HeadContact);
        formData.append("HeadSummary", this.customizeData.HeadSummary);

        formData.append("SubHeadService", this.customizeData.SubHeadService);
        formData.append("SubHeadBranch", this.customizeData.SubHeadBranch);
        formData.append("SubHeadEmployee", this.customizeData.SubHeadEmployee);
        formData.append("SubHeadAppt", this.customizeData.SubHeadAppt);
        formData.append("SubHeadContact", this.customizeData.SubHeadContact);
        formData.append("SubHeadSummary", this.customizeData.SubHeadSummary);

        formData.append("ButtonStart", this.customizeData.ButtonStart);
        formData.append("ButtonClose", this.customizeData.ButtonClose);
        formData.append("ButtonSend", this.customizeData.ButtonSend);
        formData.append("ButtonSum", this.customizeData.ButtonSum);
        formData.append("ErrorMessage", this.customizeData.ErrorMessage);

        formData.append("IframURL", this.customizeData.IframURL);
        formData.append("IframHeader", this.customizeData.IframHeader);
        formData.append("IframFooter", this.customizeData.IframFooter);
         


        this.$http.post(this.noAccessURL + 'updateUserData.php?companyId=' + this.companyID, formData).then(
            response => {
                console.log(response.body);
                this.showDismissibleAlert = true;
                this.loadCompanyInfo();
            },
            response => {

            }
        );
    },
    onLogoChanged() {
        console.log("New picture loaded");
        if (this.$refs.pictureInput.file) {
        this.image = this.$refs.pictureInput.file;
        console.log(this.image);
        } else {
        console.log("Old browser. No support for Filereader API");
        }
    },
    onLogoRemoved() 
    {
        this.image = '';

    }
    ,attemptUpload() 
    {
        if (this.image)
        {
            var formData = new FormData();
            formData.append('image', this.image, this.companyID + "-Logo.jpg");
            formData.append("companyID", this.companyID);
            
            console.log(formData);

            this.$http.post(this.noAccessURL + 'uploadLogo.php?companyId=' + this.companyID, 
                formData, {
                    'Content-Type': 'multipart/form-data'
                }).then(
                response => {
                    console.log(response.body);
                },
                response => {

                }
            );
        }
    }
  },
  beforeMount() {
    this.onLoad();
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #929292;
}

#LandingText
{
  text-align: left;
  margin-left: 15px;
}

#LandingMessage
{
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/DashboardView.vue